import React from "react";

const Loader = ({ sizeClass }) => {
  return <div className={`loader ${sizeClass}`}></div>;
};

export default Loader;
